import DashBoard from "@/components/user-admin/DashBoard.vue";

import KitchenDetail from "@/components/user-admin/KitchenDetail.vue";

var userAdminRoutes = [
    { path: '/user/admin', component: DashBoard , name: 'user-admin-dashboard'},
    { path: '/user/admin/kitchen/:id', component: KitchenDetail , name: 'user-admin-kitchen'},
   
  ];

export default userAdminRoutes;